<template>
  <div class="program-day-schedules">

    <nuttrema-loader v-if="ProgramDaySchedules.fetching"></nuttrema-loader>

    <nuttrema-empty-result v-else-if="ProgramDaySchedules.data.length === 0"
      class="is-transparent"
      icon="fal fa-calendar-exclamation is-pull-5em">
      <div slot="text">
        <h1>{{ $t('label.no_added_schedules') }}</h1>
        <h4>{{ $t('label.no_added_schedules_text') }}</h4>
      </div>
    </nuttrema-empty-result>

    <ul class="program-day-schedules__list" v-else>
      <li v-for="item in items" :key="item.id" class="program-day-schedules__time-item">

        <div class="program-day-schedules__item">
          <div class="program-day-schedules__item__left-block">
            <span class="item-time">{{ item.Time | format-time }}</span>
          </div>
          <div class="program-day-schedules__item__right-block">
            <span class="item-line"></span>
          </div>
        </div>

        <div class="program-day-schedules__item">
          <draggable
             class="is-schedule-content"
             v-model="item.Schedules"
            :options="options.draggable"
            @end="handleUpdateSchedulesSequence(item.Schedules)">
            <component
               v-for="schedule in item.Schedules"
               v-bind:is="componentName(schedule.ScheduleType.code)"
              :key="schedule.id"
              :edit="edit"
              :schedule="schedule"
              :permissions="_get(ProgramDaySchedules, 'meta.permissions')"
              :draggable="item.Schedules.length > 1"
              @editSchedule="handleEditSchedule"
              @removeSchedule="handleRemoveSchedule">
            </component>
          </draggable>
        </div>

      </li>
    </ul>

  </div>
</template>

<script>
import { sortBy, each } from 'lodash';

import PageProps from 'components/mixins/page-props';
import draggable from 'vuedraggable';

import ScheduleTypeStuffToEatSimple from './schedule-type/cmpt-schedule-type-stuff-to-eat-simple';
import ScheduleTypeStuffToEatComplex from './schedule-type/cmpt-schedule-type-stuff-to-eat-complex';

export default {
  name: 'cmpt-program-day-schedules',
  mixins: [
    PageProps,
  ],
  components: {
    draggable,
    ScheduleTypeStuffToEatSimple,
    ScheduleTypeStuffToEatComplex,
  },
  props: {
    id: {
      required: true,
      default: null,
    },
    dayID: {
      required: true,
      default: null,
    },
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
    type: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      options: {
        draggable: {
          disabled: true,
        },
      },
    };
  },
  methods: {
    componentName(value) {
      const name = value.replace(/_/g, '-');
      return `schedule-type-${name}`;
    },
    fetchProgramDaySchedules() {
      this.$store.dispatch('GetProgramDaySchedules', { id: this.id, type: this.type, dayID: this.dayID });
    },
    getSequence(items) {
      const sequence = [];
      each(items, (item, index) => {
        sequence.push({ id: item.id, seq: index });
        index += 1;
      });
      return sequence;
    },
    handleUpdateSchedulesSequence(items) {
      const sequence = this.getSequence(items);
      console.log('cmpt-program-day-schedules sequence', sequence);
      this.$emit('updateSchedulesSequence', { sequence });
    },
    handleRemoveSchedule(id) {
      console.log('cmpt-program-day-schedules handleRemoveSchedule', id);
      this.$emit('removeSchedule', id);
    },
    handleEditSchedule(id) {
      console.log('cmpt-program-day-schedules handleEditSchedule', id);
      this.$emit('editSchedule', id);
    },
  },
  computed: {
    ProgramDaySchedules() {
      return this.$store.getters.ProgramDaySchedules(this.id);
    },
    monitored() {
      return this.ProgramDaySchedules;
    },
    items() {
      return this.ProgramDaySchedules ? sortBy(this.ProgramDaySchedules.data, 'Time') : [];
    },
  },
  watch: {
    id() {
      this.fetchProgramDaySchedules();
    },
    dayID() {
      this.fetchProgramDaySchedules();
    },
    edit(value) {
      this.options.draggable.disabled = !value;
    },
  },
  created() {
    this.fetchProgramDaySchedules();
    this.options.draggable.disabled = !this.edit;
  },
  beforeDestroy() {
    this.$store.dispatch('ClearProgramDaySchedules', { id: this.id });
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";

  .program-day-schedules {
    flex-grow: 1;
    display: flex;
    align-self: stretch;

    .program-day-schedules__list {
      display: flex;
      flex-direction: column;
      flex-grow: 1;

      .program-day-schedules__time-item {
        display: flex;
        align-self: stretch;
        flex-direction: column;
        flex-shrink: 0;

        .program-day-schedules__item {
          flex-grow: 1;
          display: flex;
          align-self: stretch;
          align-items: flex-start;

          .is-schedule-content {
            display: flex;
            flex-grow: 1;
            align-self: stretch;
            flex-direction: column;
            > * {
              margin-bottom: 1em;
            }
            &.last-child {
              > * {
                margin-bottom: 0em;
              }
            }
          }

          .program-day-schedules__item__left-block {
            display: flex;
            flex-shrink: 0;
            width: 7em;
            justify-content: flex-end;

            .item-time {
              font-weight: 800;
              margin-right: 0.75em;
            }

          } // end ~ program-day-schedules__item__left-block

          .program-day-schedules__item__right-block {
            flex-grow: 1;
            display: flex;
            align-self: stretch;
            flex-direction: column;

            .item-line {
              flex-grow: 1;
              height: 1em;
              position: relative;
              margin-left: 0.75em;
              &:before {
                display: inline-block;
                width: 100%;
                height: 100%;
                top: -50%;
                left: 0;
                content: ' ';
                position: absolute;
                border-bottom: 1px solid $state-info-bg;
              }
              &.dotted:before {
                border-bottom: 1px dotted $state-info-bg;
              }
            }

          } // end ~ program-day-schedules__item__right-block

        } // end ~ program-day-schedules__item

      } // end ~ program-day-schedules__time-item

    } // end ~ program-day-schedules__list

  } // end ~ program-day-schedules

</style>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/schedules/list/cmpt-program-day-schedules.vue